import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Finance() {
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect to journal by default when on /finance
  useEffect(() => {
    if (location.pathname === '/finance') {
      navigate('/finance/journal');
    }
  }, [location.pathname, navigate]);

  // This component just handles routing, actual content is rendered by individual routes
  return null;
}

export default Finance;